import type { InjectionKey } from 'vue'

export const reloadQuotaKey = Symbol('reloadQuota') as InjectionKey<() => void>
